import { FC } from "react";
import { CircularProgress, Typography } from "@mui/material";

interface ISpinnerProps {
  // eslint-disable-next-line react/require-default-props
  color?: "primary" | "secondary" | "inherit";
}

const Spinner: FC<ISpinnerProps> = ({ color = "primary" }) => (
  <div className="loader-wrapper">
    <CircularProgress color={color} thickness={6} size={44} />
    <Typography variant="body1" color="primary">
      Loading...
    </Typography>
  </div>
);

export default Spinner;
